import { StorageType } from 'utils/storage'

function boolean(envValue: string | boolean) {
  return envValue === 'true' || envValue === true ? true : false
}

type EnvType = 'devnet' | 'testnet' | 'mainnet'
// ---------- server endpoints ----------
export const ENV: EnvType = process.env.REACT_APP_ENV! as EnvType

export const isProduction = process.env.NODE_ENV === 'production'

export const isMainnet = ENV === 'mainnet'
export const isTestnet = ENV === 'testnet'
export const isDevnet = ENV === 'devnet'

export const ZKEX_APP_V2_URL = process.env.REACT_APP_ZKEX_APP_V2_URL!

export const ZKEX_APP_URL = process.env.REACT_APP_ZKEX_APP_URL!

// In the development will use the proxy to access the server.
// In the production will use the server endpoint directly.
export const ZKEX_ENDPOINT = isProduction
  ? process.env.REACT_APP_ZKEX_ENDPOINT!
  : ''
export const ZKEX_API_BASE_URL = ZKEX_ENDPOINT + '/v1'
export const ZKEX_SERVICES_BASE_URL = ZKEX_ENDPOINT + '/services'

export const ZKEX_BROKER_BASE_URL = ZKEX_ENDPOINT + '/broker'

export const ZKEX_WS_ENDPOINT = process.env.REACT_APP_ZKEX_WS_ENDPOINT!
export const ZKEX_WS_URL = ZKEX_WS_ENDPOINT + '/v1/market/notification'

export const BINANCE_API_BASE_URL = ZKEX_ENDPOINT
export const BINANCE_WS_BASE_URL = ZKEX_WS_ENDPOINT + '/bn-ws'

export const ZKLINK_STATIC_ENDPOINT =
  process.env.REACT_APP_ZKLINK_STATIC_ENDPOINT!
export const ZKLINK_SCAN_ENDPOINT = process.env.REACT_APP_ZKLINK_SCAN_ENDPOINT!
export const ZKLINK_SCAN_API_ENDPOINT =
  process.env.REACT_APP_ZKLINK_SCAN_API_ENDPOINT!

// ---------- http config ----------
export const HTTP_TIMEOUT_MILLISECONDS = 15000 // 15 seconds

// ---------- Perp Switch ----------
export const PERP_ENABLED = boolean(process.env.REACT_APP_PERP_ENABLED!)

// ---------- Perp Switch ----------
export const EARNS_ENABLED = boolean(process.env.REACT_APP_EARNS_ENABLED!)

// This key only valid in development
export const MOCK_ENABLED = true

// ---------- ZKEX sub account id ----------
export const SUB_ACCOUNT_ID = 0

// ---------- EIP-6963 ----------
export const EIP6963_ENABLED = true

// ---------- Web3 Faucet ----------
export const WEB3_FAUCET_ENABLED = boolean(
  process.env.REACT_APP_WEB3_FAUCET_ENABLED!,
)

// ---------- Starknet ----------
export const ENABLE_STARKNET: boolean =
  boolean(process.env.REACT_APP_ENABLE_STARKNET!) && !isProduction

// ---------- storage ----------
// When the user turns on the remember switch, the signature will be stored in the browser storage.
export const STORAGE_TYPE = process.env.REACT_APP_STORAGE_TYPE! as StorageType
// Prefix is used to differentiate between devnet, testnet, and mainnet. Example: devnet: dn_, testnet: tn_, mainnet: mn_
export const STORAGE_PREFIX = process.env.REACT_APP_STORAGE_PREFIX!
// Used to control the expiration time of storage.
export const STORAGE_EXPIRE = Number(process.env.REACT_APP_STORAGE_EXPIRE!) ?? 0
// Used to control whether to use encrypted text to store in the browser.
export const STORAGE_ENCRYPT = boolean(process.env.REACT_APP_STORAGE_ENCRYPT!)

// ---------- maintenance ----------
// EvmWalletOption: true. Will display the website interface as under maintenance status.
// EvmWalletOption: false. No impact on the interface.
export const SHOW_MAINTENANCE_MODEL = boolean(
  process.env.REACT_APP_MAINTENANCE!,
)

// ---------- WalletConnect ----------
export const WALLET_CONNECT_PROJECT_ID =
  process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID!

// ---------- google recaptcha ----------
// EvmWalletOption: true. Enable google reCAPTCHA in faucet.
// EvmWalletOption: false. No impact on the interface.
export const ENABLE_GRECAPTCHA = boolean(
  process.env.REACT_APP_GRECAPTCHA_ENABLED!,
)
// GRECAPTCHA_KEY: String. google reCAPTCHA API key.
export const GRECAPTCHA_KEY = process.env.REACT_APP_GRECAPTCHA_KEY!

// ---------- polling interval for account info ----------
export const ACCOUNT_INFO_POLLING_INTERVAL = 10000
export const ORDER_FEE_RATE_POLLING_INTERVAL = 60000

export const Pow18 = '1000000000000000000'
